import { useMemo } from "react";
import { ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import { Button, Select, Tooltip, Typography } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { buildDayOptions } from "../dashboardDay";

const { Title, Text } = Typography;

const MONTH_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const DashboardHeader = ({
  year,
  month,
  day,
  lastUpdated,
  refreshing,
  onRefresh,
  onYearChange,
  onMonthChange,
  onDayChange,
  onClearFilter,
}) => {
  const { t } = useTranslation("dashboard");

  // ตัวเลือกวันที่ยาวตามเดือน/ปีที่เลือก (ก.พ. 28/29, เม.ย. 30) — คำนวณใหม่เมื่อเปลี่ยนเดือน/ปีเท่านั้น
  const dayOptions = useMemo(() => buildDayOptions(year, month), [year, month]);
  const monthOptions = useMemo(() => MONTH_VALUES.map((m) => ({ label: t(`Months.${m}`), value: m })), [t]);

  return (
    <div className="es-page-header">
      <div>
        <Title level={3} className="es-page-title">
          {t("Page.Title")}
        </Title>
        <Text className="es-page-subtitle">{t("Page.Subtitle")}</Text>
      </div>
      <div className="es-header-actions">
        <Select
          value={day}
          onChange={onDayChange}
          options={dayOptions}
          style={{ width: 80 }}
          aria-label={t("Filter.Select_Day")}
        />
        <Select
          value={month}
          onChange={onMonthChange}
          options={monthOptions}
          style={{ width: 140 }}
          aria-label={t("Filter.Select_Month")}
        />
        <Select
          value={year}
          onChange={onYearChange}
          options={[2026, 2025, 2024, 2023].map((y) => ({ label: String(y), value: y }))}
          style={{ width: 100 }}
          aria-label={t("Filter.Select_Year")}
        />
        <Button icon={<ReloadOutlined />} onClick={onClearFilter}>
          {t("Filter.Clear")}
        </Button>
        <span className="es-last-updated">
          <Tooltip title={refreshing ? t("Filter.Refreshing") : t("Filter.Refresh_Summary")}>
            <Button
              type="text"
              size="small"
              className="es-refresh-btn"
              aria-label={t("Filter.Refresh_Summary")}
              icon={<SyncOutlined spin={refreshing} />}
              onClick={onRefresh}
            />
          </Tooltip>
          {t("Filter.Last_Updated")} {lastUpdated ? dayjs(lastUpdated).format("DD/MM/YYYY HH:mm:ss") : "-"}
        </span>
      </div>
    </div>
  );
};

export default DashboardHeader;
